import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { NewsItem } from './models/news-item';
import { environment } from "../../environments/environment";
import { Apollo } from "apollo-angular";
import { Queries } from "../queries";
import { Connection } from "../models/connection";
import { NewsItemDto } from "./models/news-item-dto";

@Injectable({
  providedIn: 'root'
})

export class NewsService {
  urlPath = 'news';
  private apollo = inject(Apollo)

  constructor(private http: HttpClient) { }

  getNews(): Observable<NewsItem[]> {
    let url = environment.launchpadApi + this.urlPath + '/slipcase/latest';
    return this.http.get<NewsItem[]>(url);
  }
  
  getCompanyNews(
    pageSize: number, cursor?: string | null, categoryId?: string | null, fetchPolicy?: string): Observable<Connection<NewsItem>> {

    let variables = categoryId != null
        ? { categoryIds: [ categoryId ] } : { }

    variables = { ...variables, first: pageSize, after: cursor } as any;

    return this.apollo.watchQuery<{companyNews: Connection<NewsItemDto>}>({
      query: Queries.GetPaginatedCompanyNews(categoryId == null),
      variables: variables,
      fetchPolicy: fetchPolicy as any || 'cache-first'
    }).valueChanges.pipe(
      map(result => {
        return {
          nodes: result.data.companyNews.nodes.map(item => new NewsItem(item)),
          pageInfo: result.data.companyNews.pageInfo
        } as Connection<NewsItem>;
      }),
    );
  }

}
